export default{
    "maintenance.title" : "Sorry! We are under maintenance, we will be back shortly...",
}